import React from 'react';
import { noop } from '@prisjakt/ui-base';

import Rating from '@prisjakt/ui-rating';
import ErrorBoundary from 'src/components/error-boundary';
import { LinkToReviews } from '../LinkToReviews';
import { ProductFilters } from 'src/areas/product/components/product-filters';
import { useProductVariantsInHeaderExperiment } from 'src/hooks/experiments';

import { ProductHeaderProps } from '../../types';

import {
  CampaignBadge,
  MainSection,
  MobileHeader,
  ProductMedia,
  StyledRating,
  Title,
  TitleWrapper,
} from './styles';
import { ActionButtonsMobile } from './action-buttons';

export const ProductHeaderMobile: React.FC<ProductHeaderProps> = props => {
  const { title, product } = props;

  const showProductVariantsInHeader = useProductVariantsInHeaderExperiment();

  if (!product) {
    return null;
  }

  return (
    <MobileHeader data-test="MobileProductHeader">
      <MainSection>
        <ErrorBoundary onError={noop}>
          {product && (
            <>
              {props.currentCampaign ? (
                <CampaignBadge
                  colors={props.currentCampaign.media.colors}
                  size="large"
                />
              ) : null}
              <ProductMedia
                name={product.name}
                media={product.media}
                category={product.category}
              />
            </>
          )}
        </ErrorBoundary>
        <div>
          <TitleWrapper>
            <Title data-test="ProductTitle">{title}</Title>

            <ActionButtonsMobile product={product} />
          </TitleWrapper>

          <LinkToReviews>
            {product.userReviewSummary &&
            product.userReviewSummary.count !== 0 ? (
              <StyledRating>
                <Rating
                  hide={product.userReviewSummary.count === 0}
                  rate={product.userReviewSummary.rating}
                  count={product.userReviewSummary.count}
                  size="medium"
                  showRate
                  showRateAs="number"
                />
              </StyledRating>
            ) : null}
          </LinkToReviews>
        </div>
      </MainSection>
      {showProductVariantsInHeader && (
        <ProductFilters
          categoryId={product.category?.id}
          conditions={product.conditions}
          variantGroups={product.variantGroups}
          showProductVariantsInHeader={showProductVariantsInHeader}
        />
      )}
    </MobileHeader>
  );
};
